// extracted by mini-css-extract-plugin
export default {"infoBox":"OpenAccount_infoBox__nxtFc","iconStyle":"OpenAccount_iconStyle__Ym2LJ"};